import React from 'react';
import { Pagination } from 'antd';

const MnhaPagination = ({setCurrentPage, total}) => <Pagination onChange={(e) => setCurrentPage(e)} defaultCurrent={1} total={total} />;

export default MnhaPagination;